import Entities from 'STORE';

export const closeRightSidebarItem = (key: string): void => {
  Entities.RightSidebar.closeRightSidebarItem(key);
};
